import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../../../../context/AuthContext';
import PropTypes from "prop-types";
import { GoChevronDown } from "react-icons/go"; 
import { BiWorld } from "react-icons/bi";
import config from '../../../../config';

import './WritePost.css';

export default function WritePost({ details, CTA }) {
    const { user } = useContext(AuthContext);
    const [link, setLink] = useState("");
    const [typedText, setTypedText] = useState("");
    const [typedLink, setTypedLink] = useState("");

useEffect(() => {
    if (details.type === "wishlist") {
        setLink(`${config.publicUrl}/wishlist/${user.username}`);
    } else if (details.giveorreceive === "give" || details.giveorreceive === "receive") {
        setLink(`${config.publicUrl}/link/${user.username}`);
    }
}, [details])

useEffect(() => {
    if(!link) return;

    setTypedText(""); 
    setTypedLink("");
    
    let index = 0;
    let linkIndex = 0;

    const textInterval = setInterval(() => {
        setTypedText((prevText) => {
            if (index >= CTA.length) {
                clearInterval(textInterval);
                animateLink();
                return prevText;
        }
            return prevText + CTA[index++];
        });
    }, 80); // Adjust speed here (100ms per character)

    const animateLink = () => {
        const linkInterval = setInterval(() => {
            setTypedLink((prev) => {
                if(linkIndex >= link.length){
                    clearInterval(linkInterval);
                    return prev;
                }
                return prev + link[linkIndex++];
            })
        }, 50);
    };

    return () => clearInterval(textInterval); // Cleanup on unmount
}, [link]);

return (
<div className="x-container">
        <div className="x-post-container">
            <div className="x-top-row-container">
                <p className='cancel-post'>Cancel</p>
                <button className='x-post-btn'>Post</button>
            </div>
            <div className="photo-and-option">
                <img src={user.profilePicture} className="user-photo" alt="user-profile-picture" />
                <div className="viewer-option">
                    Everyone
                    <GoChevronDown className='down-chevron'/>
                </div>
            </div>
            <div className="post-text-container">
            <p className="x-post-text">{typedText}</p>
                <p className='x-post-link'>{typedLink}</p>
            </div>
                <div className="x-bottom-row-container">
                    <BiWorld className='x-option-icon'/>
                    <p className='post-option-desc'>Everyone can reply</p>
                </div>
        </div>
    </div>
  )
}

WritePost.propTypes = {
    details: PropTypes.object,
    index: PropTypes.number, 
    template: PropTypes.string,
    CTA: PropTypes.string,
};
